import axios from "./index";

export const _getOpenHour = () => {
  return axios.get(`/api/v1/supplier/open-hours`);
};

export const _updateOpenHour = (data) => {
  return axios.put(`/api/v1/supplier/open-hours`, data);
};
